import { render, staticRenderFns } from "./NewComment.vue?vue&type=template&id=3bc60979&"
import script from "./NewComment.vue?vue&type=script&lang=js&"
export * from "./NewComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewComment.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/NewComment.vue
// module id = 898
// module chunks = 1